module.exports = __webpack_public_path__ + "static/media/boolean_operator_xor.668907f1.svg";